// extracted by mini-css-extract-plugin
export default {"hiddenQrContainer":"QRCode_hiddenQrContainer__uLUDa"};